import { Box } from '@mui/material'
import { ReactElement, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { useGetAllTransportModesQuery } from '../../../app/redux-fetch/apiCoreQuery'
import FormSelect from '../../../components/Forms/FormSelect'
import { SectionTitleTypography } from '../../../components/Typographies/styles'
import messages from '../messages'

type DefaultValuesProps = {
    isDisabled?: boolean
}

export const DefaultValues = ({ isDisabled = false }: DefaultValuesProps): ReactElement<any, any> => {
    const { data: transportModesResult = [] } = useGetAllTransportModesQuery(undefined, { skip: isDisabled })
    const { formatMessage } = useIntl()
    const { watch } = useFormContext<any>()
    const values = watch()

    const transportModes = useMemo(() => {
        const options = transportModesResult.map((mode: any) => ({
            label: mode.name,
            value: mode.id,
        }))

        const selectedId = values?.defaultTransportModeId ?? values?.location?.defaultTransportModeId
        const selectedMode = values?.defaultTransportMode ?? values?.location?.defaultTransportMode
        if (selectedId != null && selectedMode?.name && !options.some((o: any) => o.value === selectedId)) {
            options.push({ label: selectedMode.name, value: selectedId })
        }

        return options
    }, [transportModesResult, values?.defaultTransportModeId, values?.defaultTransportMode, values?.location?.defaultTransportModeId, values?.location?.defaultTransportMode])

    return (
        <Box sx={{ mb: '16px', width: '75%' }}>
            <Box sx={{ mb: '16px' }}>
                <SectionTitleTypography>{formatMessage(messages.defaultValues)}</SectionTitleTypography>
            </Box>

            <FormSelect
                name="defaultTransportModeId"
                label={formatMessage(messages.transportMode)}
                options={transportModes}
                disabled={isDisabled}
                allowClear
            />
        </Box>
    )
}

export default DefaultValues
